import { VALIDATOR_PATTERN } from './../constants/index';
import dayjs from 'dayjs';

import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';

const nieLetters = ['X', 'Y', 'Z'];

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

export const checkNie = (identifier: string) => {
  const value = identifier.toString().toUpperCase();
  let foundNie = false;
  let i;
  for (i = 0; i < nieLetters.length; i++) {
    if (value.startsWith(nieLetters[i])) {
      foundNie = true;
    }
  }

  return foundNie;
};

export const validateBirthDate = (value: string) => {
  let error;
  const customerDate = dayjs(value, 'DD/MM/YYYY', true);
  let validAge = customerDate.isValid();
  let validRange = customerDate.isValid();
  if (customerDate.isValid() && customerDate.isBefore(dayjs())) {
    const dateFormatted = customerDate.format('YYYY-MM-DD');
    const dateSustracted = dayjs().subtract(18, 'years').format('YYYY-MM-DD');
    const minDateSustracted = dayjs()
      .subtract(100, 'years')
      .format('YYYY-MM-DD');
    validAge = !dayjs(dateFormatted).isBetween(dateSustracted, dayjs());
    validRange = dayjs(dateFormatted).isBetween(minDateSustracted, dayjs());
  } else {
    if (!customerDate.isBefore(dayjs())) {
      error = 'La fecha es superior a la actual';
    }
  }
  if (!value) {
    error = 'Indica tu fecha de nacimiendo dd/mm/aaaa';
  } else {
    if (!customerDate.isValid()) {
      error = 'El formato de fecha introducido no es válido';
    } else if (!validAge) {
      error = 'Debes ser mayor de 18 años';
    } else if (!validRange) {
      error = 'Rango de edad no válido';
    }
  }

  return error;
};

export const validatePhone = (value: string) => {
  let error;

  if (!value) {
    error = 'Indica tu móvil';
  } else if (!VALIDATOR_PATTERN.MOBILE_PHONE.test(value)) {
    error = 'Movil inválido';
  }
  return error;
};

export const validateEmail = (value: string) => {
  let error;
  if (!value) {
    error = 'Introduce un email válido';
  } else {
    if (!VALIDATOR_PATTERN.EMAIL.test(value)) {
      error = 'Introduce un email válido';
    }
  }
  return error;
};

export const validateName = (value: string) => {
  let error;
  if (!value) {
    error = 'Introduce tu nombre';
  } else {
    if (!VALIDATOR_PATTERN.NAME.test(value)) {
      error = 'Revisa los caracteres de tu nombre';
    }
  }
  return error;
};

export const validateSurname = (value: string, isNie: boolean) => {
  let error;
  let surnameOne;
  let surnameTwo;
  if (!value) {
    error = 'Introduce tus apellidos';
  } else {
    let surnameArray;
    surnameArray = value.toString().match(/([^\s]+)/g);
    const originalSurnameArray = JSON.parse(JSON.stringify(surnameArray));
    for (let i = 0; i < originalSurnameArray.length; i++) {
      if (!surnameOne) {
        if (
          !VALIDATOR_PATTERN.FORBIDDEN_SURNAME_LIST.includes(
            originalSurnameArray[i].toUpperCase()
          ) &&
          originalSurnameArray[i].length >= 2
        ) {
          surnameOne = surnameArray!.splice(0, i + 1);
          surnameOne = surnameOne.join(' ');
        }
        if (!isNie) error = 'Indica tus dos apellidos';
      } else {
        surnameTwo = surnameArray;
        surnameTwo = surnameTwo!.join(' ');
        if (!isNie) {
          if (
            VALIDATOR_PATTERN.FORBIDDEN_SURNAME_LIST.includes(
              originalSurnameArray[i].toUpperCase()
            ) ||
            surnameTwo.length < 2
          ) {
            error = 'Indica tus dos apellidos';
          } else if (!VALIDATOR_PATTERN.SURNAME.test(value)) {
            error = 'Revisa los caracteres de tus apellidos';
          } else {
            error = '';
          }
        } else {
          error = '';
        }
      }
    }
  }
  return { error, surnameOne, surnameTwo };
};

export const validateCountry = (value: string) => {
  let error;
  if (!value) {
    error = 'Indica tu país de nacimiento';
  }
  return error;
};

export const validateNationality = (value: string) => {
  let error;
  if (!value) {
    error = 'Indica tu nacionalidad';
  }
  return error;
};

export const validateAddress = (value: any) => {
  let error;
  if (value === null) {
    error = 'Introduce tu dirección';
  } else if (value?.address === '') {
    error = 'Introduce una dirección válida, por favor';
  } else if (!value?.city) {
    error = 'Selecciona una dirección que contenga una ciudad';
  }
  return error;
};

export const validateSimpleAddress = (value: any) => {
  let error;
  if (!value) {
    error = 'Introduce tu dirección';
  }
  return error;
};

export const validateAddressNumber = (value: any) => {
  let error;
  let pattern = VALIDATOR_PATTERN.ONLY_NUMBERS;
  if (value?.length > 0 && !value) {
    error = 'Añade un número';
  } else if (!pattern.test(value)) {
    error = 'Introduce solo números';
  } else if (value.length > 5) {
    error = 'No puede superar los 5 dígitos';
  }
  return error;
};

export const validateAddressDetailNumber = (value: any) => {
  let error;
  let pattern = VALIDATOR_PATTERN.ONLY_NUMBERS;
  if (!value) {
    error = 'Añade el número de tu dirección';
  } else if (!pattern.test(value)) {
    error = 'Introduce solo números';
  } else if (value.length > 5) {
    error = 'No puede superar los 5 dígitos';
  }
  return error;
};

export const validateAuxAddress = (value: any) => {
  let error;
  let chars = RegExp(/[<>&/]/g);
  if (value.length > 20) {
    error = 'Has superado el limite de caracteres';
  } else if (chars.test(value)) {
    error = 'No se admiten caracteres especiales';
  }
  return error;
};

export const validateContractType = (value: any) => {
  let error;
  if (!value) {
    error = 'Introduce tu situación laboral';
  }
  return error;
};

export const validateMonthlyIncome = (value: any) => {
  let error;
  let pattern = VALIDATOR_PATTERN.DECIMAL_AMOUNT;
  if (!value) {
    error = 'Introduce tus ingresos netos mensuales';
  } else if (!pattern.test(value)) {
    error = 'Introduce una cantidad (ej: 10.50)';
  }
  return error;
};

export const validatePostalCode = async (value: any) => {
  let error;
  let pattern = VALIDATOR_PATTERN.POSTAL_CODE;
  if (!value) {
    error = 'Introduce código postal';
  } else if (value.length < 5) {
    error = 'El código postal debe tener 5 dígitos';
  } else if (!pattern.test(value)) {
    error = 'Introduce un código postal válido';
  }
  return error;
};

export const validateSusAmount = (value: number) => {
  let error;
  if (!value) {
    error = 'Introduce un importe válido';
  } else if (value < 200) {
    error = 'Introduce un importe superior a 200 €, por favor';
  }
  return error;
};
